module.exports = __webpack_public_path__ + "img/mic1.aaded14b.svg";